import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { DetailedOrderInQueue, OrderInQueue } from 'app/models/orderInQueue.model';
import { Select } from '@ngxs/store';
import { OrdersState } from 'app/state-management/states/orders.states';

@UntilDestroy()
@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None
})
export class OrderListComponent implements OnInit {
  isLoading = true;

  orders: OrderInQueue[];

  @Select(state => state.orders.ordersList) orders$: Observable<OrderInQueue[]>;
  @Select(state => state.orders.ordersListCount) ordersCount$: Observable<number>;
  @Select(OrdersState.currentOrder) currentOrder$: Observable<DetailedOrderInQueue>;

  constructor(
  ) {
  }

  ngOnInit(): void {
    this.currentOrder$
      .pipe(
        untilDestroyed(this)
      )
      .subscribe(currentOrder => {
        if (currentOrder && currentOrder.details) {
          this.isLoading = false;
        } else {
          this.isLoading = true;
        }
      });
  }
}

